import { prefix } from "./constants";

export function generateClassName(name: string, color: string, size: string, shape = "normal", className = ""): string {
  return `${prefix}-${name} ${prefix}-${name}-${color} ${prefix}-${name}-${size} ${shape === "normal" ? "" : shape === "round" ? "pill" : shape} ${className}`.trim();
}

export function generateGuid(): string {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (char) => {
    const random = (Math.random() * 16) | 0;
    const value = char === "x" ? random : (random & 0x3) | 0x8;
    return value.toString(16);
  });
}
export function decodeHtml(value: string | undefined | null): string | undefined {
    if (!value) return undefined; 
    const txt = document.createElement("textarea");
    txt.innerHTML = value;
    return txt.value;
}

export function decodeHtmlAttributes(attrs?: { [key: string]: any }): { [key: string]: any } | undefined {
    if (!attrs) return attrs;

    const decoded: { [key: string]: any } = {};
    for (const key in attrs) {
        const val = attrs[key];
        decoded[key] = typeof val === "string" ? decodeHtml(val) : val;
    }

    return decoded;
}
